import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '@/constants/Common'
import {
  PASSWORD_MATCH,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_NO_WHITESPACE,
  PASSWORD_REQUIRED,
  PASSWORD_STRENGTH,
} from '@/constants/MessageConstants'
import * as Yup from 'yup'

const ChangePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(PASSWORD_REQUIRED),
  newPassword: Yup.string()
    .required(PASSWORD_REQUIRED)
    .min(MIN_PASSWORD_LENGTH, PASSWORD_MIN_LENGTH)
    .matches(/^\S*$/, PASSWORD_NO_WHITESPACE)
    .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{6,})/, PASSWORD_STRENGTH)
    .max(MAX_PASSWORD_LENGTH, PASSWORD_MAX_LENGTH),
  confirmPassword: Yup.string()
    .required(PASSWORD_REQUIRED)
    .oneOf([Yup.ref('newPassword')], PASSWORD_MATCH),
})

export default ChangePasswordValidationSchema
